import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts';
const GraphCard = ({ option = {}, height='250px', onChartClick, widenClickArea = false }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);
    chartInstance.setOption(option);

    const handleResize = () => chartInstance.resize();
    window.addEventListener('resize', handleResize);

    let handleZrClick;
    if (onChartClick) {
      chartInstance.on('click', (params) => onChartClick(params));

      if (widenClickArea) handleZrClick = (event) => {
        if (event.target) return; // already handled by series/component click above
        const point = [event.offsetX, event.offsetY];
        if (!chartInstance.containPixel({ gridIndex: 0 }, point)) return;
        const pointInGrid = chartInstance.convertFromPixel({ seriesIndex: 0 }, point);
        const dataIndex = pointInGrid?.[0];
        if (dataIndex == null || Number.isNaN(dataIndex)) return;
        const rounded = Math.round(dataIndex);
        const seriesData = option?.series?.[0]?.data;
        if (rounded < 0 || (seriesData && rounded >= seriesData.length)) return;
        onChartClick({ componentType: 'series', dataIndex: rounded });
      };
      if (handleZrClick) chartInstance.getZr().on('click', handleZrClick);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      if (handleZrClick) chartInstance.getZr().off('click', handleZrClick);
      chartInstance.dispose();
    };
  }, [option])
  
  return (
    <div ref={chartRef} className="chart-canvas" style={{ height, cursor: onChartClick ? 'pointer' : 'default' }} />
  )
}

export default GraphCard